function server() {
  // return "http://localhost/api/v1";
  // return "http://192.168.225.28/shop"
  // return "http://localhost/sshop-backend/web";
  return "https://shop.strackit.com/shop/web";
}

export default server;
